import { createContext, type ReactNode, useContext, useState } from 'react';

type HeaderVisibilityContextValue = {
  hideHeaderOnMobile: boolean;
  setHideHeaderOnMobile: (hide: boolean) => void;
};

const HeaderVisibilityContext = createContext<HeaderVisibilityContextValue | null>(null);

/**
 * Controls whether the global HeaderNav is hidden on mobile viewports.
 * Used by immersive experiences (SRP feed view) that take over the full
 * viewport on mobile.
 */
export function HeaderVisibilityProvider({ children }: { children: ReactNode }) {
  const [hideHeaderOnMobile, setHideHeaderOnMobile] = useState(false);

  return (
    <HeaderVisibilityContext.Provider value={{ hideHeaderOnMobile, setHideHeaderOnMobile }}>
      {children}
    </HeaderVisibilityContext.Provider>
  );
}

const defaultValue: HeaderVisibilityContextValue = {
  hideHeaderOnMobile: false,
  setHideHeaderOnMobile: () => {},
};

export function useHeaderVisibility(): HeaderVisibilityContextValue {
  const ctx = useContext(HeaderVisibilityContext);
  return ctx ?? defaultValue;
}
